<template>
  <div>
    <v-card
      v-if="order"
      class="py-3 px-3 mb-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.items') }}
          <br>
          <span class="text-normal">
            {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.overall') }}
            {{ order.ecoCreditsDetail ? order.ecoCreditsDetail.length : 0 }}
            {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.products') }}
            {{ order.ecoCredits.products_quantity ? order.ecoCredits.products_quantity : 0 }}
            {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.pieces') }}
          </span>
        </h4>
      </div>

      <v-row>
        <v-col
          cols="2"
          class="text-left">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.amount') }}
        </v-col>
        <v-col
          cols="4"
          class="text-center">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.note') }}
        </v-col>
        <v-col
          cols="3"
          class="text-right">
          {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.number') }}
        </v-col>
        <v-col
          cols="3"
          class="text-right">
          Počet peněz
        </v-col>
      </v-row>
      <v-row
        v-for="(ecoItem, index) in order.ecoCreditsDetail"
        :key="index"
        class="row order-item">
        <v-col
          cols="2"
          class="text-left">
          {{ ecoItem.products_quantity }}
        </v-col>
        <v-col
          cols="4"
          class="text-center">
          {{ ecoItem.note }}
        </v-col>
        <v-col
          cols="3"
          class="text-right">
          {{ ecoItem.credits_quantity }}
        </v-col>
        <v-col
          cols="3"
          class="text-right">
          {{ formatAmounts(ecoItem.amounts_quantity, order.currencyId) }}
        </v-col>
      </v-row>

      <v-row class="h-separator" />

      <v-row>
        <v-col
          cols="12"
          class="pb-6">
          <v-row>
            <v-col
              cols="6"
              class="py-0">
              {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.credits') }}/peněz
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              {{ order.ecoCredits.credits_quantity ? order.ecoCredits.credits_quantity : 0 }}
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              {{ formatAmounts(order.ecoCredits.amounts_quantity, order.currencyId) }}
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="6"
              class="py-0">
              {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.transit') }}
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              -
              {{ order.ecoCredits.shipping ? order.ecoCredits.shipping : 0 }}
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              - 0
            </v-col>
          </v-row>

          <v-row v-if="order.ecoCredits.oversized_shipping || order.ecoCredits.oversized_shipping_fine">
            <v-col
              cols="6"
              class="py-0">
              <div>
                {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.oversized') }}
              </div>
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              <div v-if="order.ecoCredits.oversized_shipping_fine">
                -
                {{ order.ecoCredits.oversized_shipping_fine }}
              </div>
              <div v-else>
                {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.included') }}
              </div>
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              - 0
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="6"
              class="py-0">
              <div class="mt-4 font-weight-bold">
                {{ $vuetify.lang.t('$vuetify.ecoChallengeDetail.total') }}
              </div>
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              <div class="mt-4 font-weight-bold">
                {{ order.ecoCredits.real_credits_quantity ? order.ecoCredits.real_credits_quantity : 0 }}
              </div>
            </v-col>
            <v-col
              cols="3"
              class="d-flex flex-column align-end justify-end py-0">
              <div class="mt-4 font-weight-bold">
                {{ formatAmounts(order.ecoCredits.amounts_quantity, order.currencyId) }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { formatAmounts } from '@/common/helpers/currency';

export default {
  props: {
    order: {
      type: Object,
      default: null,
    },
  },
  methods: {
    formatAmounts,
  },
};
</script>

<style scoped>
.order-item {
  border-top: 1px solid #e0e0e0;
}

.h-separator {
  margin-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}
</style>
